import { render, staticRenderFns } from "./GroupsRetrieve.vue?vue&type=template&id=91ed04d6"
import script from "./GroupsRetrieve.vue?vue&type=script&lang=js"
export * from "./GroupsRetrieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports